export default __webpack_public_path__ + "static/media/picture3.e70d6216.png";